import React, { useRef } from 'react';
import { DocumentSubCategory, DocumentUploadCategory, PropertyDocument, SUBCATEGORY_LABELS } from 'types/Documents';
import Button from 'components/Button/Button';
import InfoIcon from 'components/Icons/InfoIcon';
import FileTypeIcon from 'components/Icons/FileTypeIcon';
import { ModalRef } from 'components/Modal/Modal';
import UploadSvg from 'assets/icons/upload.svg?react';
import CameraIcon from 'assets/icons/camera.svg?react';
import { CategoryBadge, DoneBadge } from '../utils';
import { SUPPORTED_FILE_TYPES } from 'utils/documents';
import styles from '../NewOwnerOnboarding.module.css';

interface EntryExitPhotosItemProps {
    category: DocumentUploadCategory | undefined;
    entryExitPhotosDocuments: PropertyDocument[];
    uploadDocuments: (e: React.ChangeEvent<HTMLInputElement>, category: DocumentUploadCategory) => Promise<void>;
    infoRef: React.RefObject<ModalRef>; // ref to the modal that shows the info for the item
    disableInteractions: boolean;
}

function EntryExitPhotosItem({
    category: entryExitCategory,
    entryExitPhotosDocuments,
    uploadDocuments,
    infoRef,
    disableInteractions,
}: EntryExitPhotosItemProps): JSX.Element {
    if (!entryExitCategory) return <></>;

    const entryExitInputRef = useRef<HTMLInputElement>(null);

    const uploadEntryExitFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await uploadDocuments(e, entryExitCategory);
    };

    return (
        <div
            className={`${styles.item} ${
                entryExitPhotosDocuments.length > 0 ? styles.done : entryExitCategory.is_required ? styles.required : ''
            }`}
        >
            <CameraIcon className={styles.itemIcon} />
            <div>
                <div className={styles.titleRow}>
                    <span className={styles.itemTitle}>{SUBCATEGORY_LABELS[DocumentSubCategory.PHOTO]}</span>
                    <CategoryBadge category={entryExitCategory} />
                </div>
                <p className={styles.itemDescription}>
                    Images of the parking access points in your garage for efficient installation.
                </p>
            </div>
            <div className={styles.actions}>
                {entryExitPhotosDocuments.length > 0 && <DoneBadge />}
                <button
                    className={styles.infoButton}
                    type="button"
                    aria-label="More info"
                    onClick={() => infoRef.current?.openModal()}
                >
                    <InfoIcon />
                </button>
                <input
                    ref={entryExitInputRef}
                    type="file"
                    hidden
                    multiple
                    accept={SUPPORTED_FILE_TYPES}
                    onChange={uploadEntryExitFiles}
                />
                <Button
                    color="info"
                    size="sm"
                    onClick={() => entryExitInputRef.current?.click()}
                    className={styles.actionButton}
                    disabled={disableInteractions}
                >
                    <UploadSvg />
                    Upload
                </Button>
            </div>
            {entryExitPhotosDocuments.map((file, i) => (
                <div key={i} className={styles.fileItem}>
                    <FileTypeIcon fileType={file.file_type} size={20} />
                    <span className={styles.fileName}>{file.display_name}</span>
                </div>
            ))}
        </div>
    );
}

export default EntryExitPhotosItem;
